import { createRouter, createWebHashHistory } from 'vue-router';

const router =  createRouter({
    // base: process.env.VUE_APP_PATH,
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: '首页',
            component: () => import('@/views/index.vue')
        },{
            path: '/gsxw',
            name: '公司新闻',
            component: () => import('@/views/companyNews.vue')
        },{
            path: '/ncpxx',
            name: '农产品信息',
            component: () => import('@/views/product.vue')
        },{
            path: '/cybj',
            name: '产业布局',
            component: () => import('@/views/industry.vue')
        },{
            path: '/tzzgx',
            name: '投资者关系',
            component: () => import('@/views/investor.vue')
        },{
            path: '/ztb',
            name: '招投标',
            component: () => import('@/views/bidding.vue')
        },{
            path: '/gydr',
            name: '关于东日',
            component: () => import('@/views/aboutDongri.vue')
        },{
            path: '/details',
            name: '详情',
            component: () => import('@/views/details.vue')
        },{
            path: '/search',
            name: '搜索列表',
            component: () => import('@/views/search.vue')
        },
    ]
})
router.beforeEach((to, from, next) => {
    window.stop();
    next(); // 确保调用 next() 方法以继续路由导航
});
router.afterEach((to, from) => {
    // 在每次路由跳转后，将页面滚动到顶部
    window.scrollTo(0, 0);
});

export default router;